import axios from "axios"
import { Link } from "react-router-dom"
import React, { useEffect, useState } from "react"
import { API } from "../../api"
import CreateProductCardSmall from "../../utils/createProductCardSmall"
import Loading from "../loading"

export default function StoreBakery() {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    axios
      .get(
        `${API}products?categorie=bakery&fields=name,mrp,coverImage,ratting,rattingPerson,stock,sellingPrice,unit,packaged,company,veg,_id&limit=7`
      )
      .then(res => {
        setLoading(false)
        setProducts(res.data.data.allProduct)
      })
  }, [])
  return (
    <section className="store-bakery mw-14">
      <div className="double-banner">
        <Link to="/categroy/bakery">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1633704648_Oreo_web_mini.jpg"
            className="banners"
            alt="bakery-banner"
          />
        </Link>
        <Link to="/categroy/bakery">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1607437940_buybig_webmini.jpg"
            className="banners"
            alt="bakery-banner"
          />
        </Link>
      </div>

      <div className="home-heading">
        <h2>Bakery Products</h2>
        <Link to="/category/bakery" className="link">
          See All
        </Link>
      </div>
      <div className="d-flex overflow-auto">
        {products.map(CreateProductCardSmall)}

        {loading && <Loading />}
      </div>
    </section>
  )
}
